import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import api from '../../utils/api';
import './LeftSide.css';

const LeftSide = () => {
    const { pathname } = useLocation();
    const usersActive = pathname === '/' || pathname === '/users';
    const [pendingCount, setPendingCount] = useState(0);

    const fetchPendingCount = async () => {
        try {
            const res = await api.get('/settlement/wire-transfers/pending-count');
            if (res.data && res.data.success) {
                setPendingCount(res.data.count);
            }
        } catch (error) {
            console.error('Failed to fetch pending count', error);
        }
    };

    useEffect(() => {
        fetchPendingCount();
        // 5분마다 갱신
        const intervalId = setInterval(fetchPendingCount, 5 * 60 * 1000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="left-side-menu admin-left-nav">
            <div className="h-100" data-simplebar>
                <div id="sidebar-menu">
                    <ul id="side-menu">
                        <li>
                            <NavLink to="/users" className={usersActive ? 'active' : undefined}>
                                <i className="mdi mdi-account-cog"></i>
                                <span> 사용자관리 </span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/admins"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                            >
                                <i className="mdi mdi-account-tie"></i>
                                <span> 관리자관리 </span>
                            </NavLink>
                        </li>

                        <li>
                            <NavLink
                                to="/loginlogs"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                            >
                                <i className="mdi mdi-database-lock"></i>
                                <span> 접속로그 </span>
                            </NavLink>
                        </li>

                        <li>
                            <NavLink
                                to="/logs"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                            >
                                <i className="mdi mdi-database-search"></i>
                                <span> 검색로그 </span>
                            </NavLink>
                        </li>
                        {/* <li>
                            <NavLink
                                to="/QuotaUsageLog"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                            >
                                <i className="mdi mdi-chart-timeline-variant"></i>
                                <span> 한도 사용량로그 </span>
                            </NavLink>
                        </li> */}
                        <li>
                            <NavLink
                                to="/settlement"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                                style={{ position: 'relative' }}
                            >
                                <i className="mdi mdi-file-find-outline"></i>
                                <span> 정산관리 </span>
                                {pendingCount > 0 && (
                                    <span 
                                        className="badge bg-danger shadow-sm" 
                                        style={{ 
                                            position: 'absolute',
                                            right: '14px',
                                            top: '0',
                                            bottom: '0',
                                            margin: 'auto',
                                            display: 'inline-flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center', 
                                            width: pendingCount > 9 ? 'auto' : '18px', 
                                            minWidth: '18px',
                                            height: '18px', 
                                            borderRadius: '9px', 
                                            padding: pendingCount > 9 ? '0 5px' : '0',
                                            fontSize: '11px',
                                            fontWeight: 'bold',
                                            lineHeight: '1'
                                        }}
                                    >
                                        {pendingCount}
                                    </span>
                                )}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/notices"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                            >
                                <i className="mdi mdi-bullhorn-outline"></i>
                                <span> 공지사항 </span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/update-posts"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                            >
                                <i className="mdi mdi-newspaper-variant-outline"></i>
                                <span> 업데이트공지 </span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/settings"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                            >
                                <i className="mdi mdi-cog-outline"></i>
                                <span> 환경설정 </span>
                            </NavLink>
                        </li>
                    </ul>
                </div>

                <div className="clearfix"></div>
            </div>
        </div>
    );
};
export { LeftSide };
